import { defineMessages } from 'react-intl';

export default defineMessages({
  commitsAheadMessage: {
    id: 'bitkit.branchDivergence.commitsAheadMessage',
    description:
      'Text for tooltip showing how many commits ahead the branch is',
    defaultMessage:
      '{commitsAhead, plural, one {{commitsAhead} commit ahead of {mainBranchName}} other {{commitsAhead} commits ahead of {mainBranchName}}}',
  },
  commitsBehindMessage: {
    id: 'bitkit.branchDivergence.commitsBehindMessage',
    description:
      'Text for tooltip showing how many commits behind the branch is',
    defaultMessage:
      '{commitsBehind, plural, one {{commitsBehind} commit behind {mainBranchName}} other {{commitsBehind} commits behind {mainBranchName}}}',
  },
  notAvailableMessage: {
    id: 'bitkit.branchDivergence.commitActivityNotAvailable',
    description: 'Text for tooltip when the divergence isnt available',
    defaultMessage: 'Commit activity unavailable...',
  },
});
